import React, { useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../styles'
import Button from '../button/Button'
import { useMediaQuery } from 'react-responsive'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'
import { displayModal } from '../../modules/reducers/modal/actions'
import { modalTypes } from '../../enums/modalTypeEnum'
import { RootState } from '../../modules/reducers'
import portals from '../../enums/portalsEnum'
import { Theme } from '@material-ui/core/styles/createMuiTheme'
import { MakeRequestContext } from '../../modules/requests/makeRequest/MakeRequestContext'
import { ASSURANCE_CONCERN } from '../../modules/requests/makeRequest/stepper/Stepper'
import { CONTRACT } from '../../modules/requests/makeRequest/stepper/step2/RequestPurpose'
import { requestType } from '../../enums/contractsEnum'


const useStyle = makeStyles<Theme, { environnementResidence: boolean }>(
	(theme) => (
		{
			...styles(theme),
			topAlertStyle: {
				background: props => props.environnementResidence ? "#F3AC97" : theme.palette.accessibility.main,
				width: '100%',
				color: 'white',
				marginBottom: 25,

				'& .container': {
					position: 'relative',
					display: 'flex',
					alignItems: 'center',
					textAlign: 'left',
					width: '80%',
					maxWidth: 1100,
					margin: 'auto',
					padding: '25px 0',

					'& div:first-child': {
						width: '85%',
						marginRight: 50,

						'& p:first-child': {
							marginTop: 0
						},
						'& p:last-child': {
							marginBottom: 0
						}
					},
					'& div:nth-child(2)': {},
					'& img': {
						position: 'absolute',
						top: 15,
						right: 0,
						width: 24,
						background: '#4cc4c2',
						padding: 7,
						borderRadius: '100%',
						boxSizing: 'border-box',
						cursor: 'pointer'
					}
				}
			},
			topAlertLargeScreenStyle: {
				paddingTop: 100
			},
			topAlertSmallScreenStyle: {
				paddingTop: 65,
				'& .container': {
					'& div:first-child': {
						marginRight: 10
					}
				}
			},
			circularProgressStyle: {
				marginBottom: 20
			},
			circularProgressLargeScreenStyle: {
				paddingTop: 100
			},
			circularProgressSmallScreenStyle: {
				paddingTop: 65
			},
			buttonTextStyle: {
				width: 'max-content'
			},
			titreStyle: {
				fontSize: '16px !important'
			}
		}
	))

const AssuranceAlert = () => {
	const classes = useStyle({ environnementResidence: process.env.REACT_APP_TARGET === portals.residence })
	const intl = useIntl()
	const assurance = useSelector((state: RootState) => state.assurance)
	const { request } = useContext(MakeRequestContext)

	const dispatch = useDispatch()

	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const topAlertClass: ClassValue = classNames(
		classes.topAlertStyle,
		{
			[classes.topAlertLargeScreenStyle]: isLargeScreen,
			[classes.topAlertSmallScreenStyle]: !isLargeScreen
		}
	)
	const TitreAlertClass: ClassValue = classNames(
		classes.text4,
		classes.titreStyle
	)

	return (
		<div className={topAlertClass}>
			<div className="container">
				<div>
					<p className={TitreAlertClass}>
						<FormattedMessage
							id="customAlert.assurance.title"
							defaultMessage="Important"
							description="Custom Alert Title"
						/>
					</p>

					<p className={classes.text1}>
						<FormattedMessage
							id={`customAlert.assurance.${assurance.finAssuranceProche ? 'proche' : assurance.assuranceFinie ? 'finie' : ''}.informations`}
							defaultMessage="Votre attestation d’assurance arrive bientôt à échéance. Pensez à nous transmettre votre nouvelle attestation au plus vite"
							description="Custom Alert Informations"
						/>
					</p>
				</div>


				<div>
					<Button
						onClick={() => {
							request.requestConcern = ASSURANCE_CONCERN
							request.requestPurpose = CONTRACT
							request.requestType = requestType.administrative
							dispatch(displayModal(modalTypes.demandes))
						}}
						color="colorWhite"
						textStyle="text2"
						disabled={false}
						background="backgroundInherit"
						buttonStyle={classes.buttonTextStyle}
						border="borderWhite"
						ariaLabel={
							intl.formatMessage(
								{
									id: 'customAlert.assurance.deposit',
									defaultMessage: 'Déposer',
									description: 'Aria label text'
								}
							)
						}
					>
						<FormattedMessage
							id="customAlert.assurance.deposit"
							defaultMessage="Déposer"
							description="Button text Subscribe"
						/>
					</Button>
				</div>
			</div>
		</div>
	)
}

export default AssuranceAlert